export const FreeQrCodeGeneratorPageJsonLd = {
  '@context': 'https://schema.org',
  '@type': 'SoftwareApplication',
  name: 'Free QR Code Generator',
  url: 'https://app.flowcode.com/free-qr-code-generator',
  description:
    'Generate high-quality QR codes for free with Flowcode’s easy-to-use QR Code Generator. Customize your design, download in seconds, and track performance.',
  Image:
    'https://app.flowcode.com/_next/image?url=%2Fgraphics%2Flocg%2FHighest-converting-qr-code.jpg&w=1200&q=75',
  applicationCategory: 'DesignApplication',
  operatingSystem: 'Windows, OSX, Android, iOS, Linux',
  offers: {
    '@type': 'Offer',
    priceCurrency: 'USD',
    price: '0.00'
  },
  creator: {
    '@type': 'Organization',
    name: 'Flowcode',
    url: 'https://flowcode.com',
    description:
      'Flowcode® is an enterprise QR code platform that connects your offline fans to your online brand. Measure the ROI of your campaigns and capture first-party data essential for driving your business forward.',
    knowsAbout:
      'qr codes, software, landing pages, marketing, offline marketing, technology, analytics',
    logo: 'https://cdn.prod.website-files.com/675629dafe17320a4b69e8d2/681cc5c80775c5f9038ac70e_Flowcode-logo-circle-400x400-350pxlogo%20(1).png',
    foundingDate: '2019-02-19',
    sameAs: [
      'https://www.facebook.com/GetFlowcode/',
      'https://www.instagram.com/getflowcode/',
      'https://twitter.com/Flowcode',
      'https://www.youtube.com/c/getflowcode',
      'https://www.linkedin.com/company/flowcode-qr/mycompany/',
      'https://www.tiktok.com/@getflowcode'
    ]
  }
}
